$(document).ready(function() {
  //on scroll down, add invisible class to section-header, else remove it
  /*let lastScroll = 0;
  $(window).scroll(function() {
      let scroll = $(window).scrollTop();
      if (scroll > lastScroll) {
          $('.section-header').addClass('invisible');
      } else {
          $('.section-header').removeClass('invisible');
      }
      lastScroll = scroll;
  });*/

  $(document).on('click','.variant-picker-trigger',function(){
      $('body').addClass('overflow-hidden');
      $('.form-sidebar').addClass('expanded')
    });
    $(document).on('click','.close-sidebar,.sidebar-overlay',function(){
      $(this).parents('.form-sidebar').removeClass('expanded');
      $('body').removeClass('overflow-hidden');
    });

  $(document).on('click','.form-sidebar:not(.bundle-sidebar) .option-cell.has-value',function(){
      const optionName = $(this).parents('.selector-wrapper').attr('data-option');
      const optionValue = $(this).attr('data-value');
      const selectedOption = $('variant-picker').find(`.option-selector[data-option="${optionName}"] input[value="${optionValue}"]`);
      $(this).addClass('selected');
      $(this).parents('.table-body').find('.option-cell').not($(this)[0]).removeClass('selected');
      $('variant-picker').find(`.option-selector[data-option="${optionName}"] input`).prop('checked',false);
      selectedOption.prop('checked',true);
      $('variant-picker')[0].dispatchEvent(new Event('change'));
  });


  $(document).on('change','.form-sidebar .selector-wrapper input[type="radio"]',function(){
      const siblings = $(this).parents('.selector-wrapper').siblings();
      const inputEl = $(this);
      let allSelected = true;
      $(this).parents('.selector-wrapper').addClass('selected');
      siblings.each(function(){
          if(!$(this).hasClass('selected')){
              allSelected = false;
              return false;
          }
      });
      if(allSelected){
          $('.form-sidebar .selector-wrapper').each(function(){
              const optionName = $(this).attr('data-option');
              const optionValue = $(this).find('input:checked').val();
              const selectedOption = $('variant-picker').find(`.option-selector[data-option="${optionName}"] input[value="${optionValue}"]`);
              $('variant-picker').find(`.option-selector[data-option="${optionName}"] input`).prop('checked',false);
              selectedOption.prop('checked',true);
          });
          $('variant-picker')[0].dispatchEvent(new Event('change'));
      }
  });

  $(document).on('click','.form-sidebar:not(.bundle-sidebar) .sidebar-atc, .add-to-cart-trigger',function(){
      $(this).attr('disabled',true);
      $(this).text('Adding to cart...');
      $('.js-product-form button[name="add"]').trigger('click');
  });
  $(document).on('click','.bis-trigger-btn',function(){
      $('#BIS_trigger').click();
  });
  

  if($('.detail.product-column-right').length){
      function setBottomPosition(){
          if($(window).width() < 768){
              const productForm = $('.detail.product-column-right').find('.product-form');
              const productFormHeight = productForm.outerHeight();
              const productTitleHeight = productForm.find('.price-title').outerHeight();
              const inputRowHeight = productForm.find('.input-row').outerHeight();
              $('.detail.product-column-right').css('bottom', (productFormHeight - productTitleHeight - inputRowHeight - 20) *-1);
          }
      }
      setBottomPosition();
      $(window).resize(function(){
          setBottomPosition();
      });
      
      const accordionDescription = $('#accordion-description');
      const accordionDescriptionOffset = accordionDescription.offset().top;
      $(window).scroll(function() {
      const windowBottom = $(window).scrollTop() + $(window).height();
          if($(window).width() < 769){
              if(windowBottom > accordionDescriptionOffset + 90){
                  $('.detail.product-column-right').css('position','static');
              }else{
                  $('.detail.product-column-right').css('position','sticky');
              }
          }
      });

  }


  //on window scroll, if window top touches .section-main-product, add .visible to .sticky-atc-pdp
  if($('.sticky-atc-pdp').length){
      const stickyAtcPdp = $('.sticky-atc-pdp');
      const sectionMainProduct = $('.section-main-product');
      const sectionMainProductOffset = sectionMainProduct.offset().top;
      const sectionMainProductHeight = sectionMainProduct.outerHeight();
      const sectionMainProductBottom = sectionMainProductOffset + sectionMainProductHeight;
      const windowWidth = $(window).width();

      $(window).scroll(function() {
        if($(window).width() < 768){
          if($(window).scrollTop() > sectionMainProductBottom - 100 && windowWidth < 768){
              stickyAtcPdp.addClass('visible');
          }else{
              stickyAtcPdp.removeClass('visible');
          }
        }
      });
  }

  if(sessionStorage.getItem('newsletterpopup') == 'true'){
      $('.newsletter-trigger').remove();
    }else{
      $('.newsletter-trigger').addClass('visible');
    }
  
    $(document).on('click','.close-newsletter-trigger',function(){
      $('.newsletter-trigger').removeClass('visible');
      sessionStorage.setItem('newsletterpopup', 'true');
    })

    $(document).on('click','.sidebar-trigger',function(e){
      e.preventDefault(); 
      const target = $(this).attr('data-target');
      const sidebar = $(`.sidebar-main[data-sidebar-id="${target}"]`);
      sidebar.addClass('expanded');
      $('body').addClass('overflow-hidden');
    })

    $(document).on('click', 'a[href*="virtual-body-sizing"]', function(e){
      e.preventDefault(); 
      $('body').addClass('overflow-hidden');
      $(`.sidebar-main[data-sidebar-id="virtual-sizing"]`).addClass('expanded');
    });
    
    $(document).on('click','.sidebar-overlay',function(){
      $(this).parents('.sidebar-main').removeClass('expanded');
      $('body').removeClass('overflow-hidden');
    })

  if($('.subscribe-page').length > 0){
      const success_message = $('.subscribe-page').find('[data-success-message]').html();
      const target = document.getElementById('mce-success-response');
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (target.innerHTML === "Thank you for subscribing!" && success_message) {
            $('#mc-embedded-subscribe-form').addClass('success');
            sessionStorage.setItem('newsletterpopup', 'true');
            target.innerHTML = success_message;
          }else if(target.innerHTML === "You're already subscribed, your profile has been updated. Thank you!"){
            $('#mc-embedded-subscribe-form').addClass('success');
          }
        });
      });
      var config = { attributes: true, childList: true, characterData: true };
      observer.observe(target, config);
  }

  function checkScreenWidth() {
      if (window.innerWidth <= 767) {
        return;
      }
  
      const stickyElement = document.querySelector('.product-column-right');
      if (!stickyElement) {
        return;
      }
      const startPosition = stickyElement.getBoundingClientRect().top;
  
      let endScroll = window.innerHeight - stickyElement.offsetHeight - 500;
      let currPos = window.scrollY;
      let screenHeight = window.innerHeight;
      let stickyElementHeight = stickyElement.offsetHeight;
      let topGap = 40;
      let bottomGap = 40;
  
      setTimeout(() => {
        if (stickyElement.hasAttribute('data-top-gap')) {
          const dataTopGap = stickyElement.getAttribute('data-top-gap');
          topGap = dataTopGap === 'auto' ? startPosition : parseInt(dataTopGap);
          if(dataTopGap == 'middle'){
              topGap = (window.innerHeight - $('.section-header').outerHeight() - stickyElement.offsetHeight) / 2 + $('.section-header').outerHeight();
          }
        }

  
        if (stickyElement.hasAttribute('data-bottom-gap')) {
          bottomGap = parseInt(stickyElement.getAttribute('data-bottom-gap'));
        }
        stickyElement.style.position = 'sticky';
        stickyElement.style.top = `${topGap}px`;
        stickyElement.style.height = 'fit-content';
      }, 100);

      stickyElement.style.position = 'sticky';
      stickyElement.style.top = `${topGap}px`;
      stickyElement.style.height = 'fit-content';
  
      function positionStickySidebar() {
        endScroll = window.innerHeight - stickyElement.offsetHeight - bottomGap;
        const stickyElementTop = parseInt(stickyElement.style.top.replace('px', ''));
  
        if (stickyElementHeight + topGap + bottomGap > screenHeight) {
          if (window.scrollY < currPos) {
            if (stickyElementTop < topGap - 1) {
              stickyElement.style.top = `${stickyElementTop + currPos - window.scrollY}px`;
            } else if (stickyElementTop >= topGap) {
              stickyElement.style.top = `${topGap}px`;
            }
          } else {
            if (stickyElementTop > endScroll) {
              stickyElement.style.top = `${stickyElementTop + currPos - window.scrollY}px`;
            } else if (stickyElementTop < endScroll && stickyElementTop !== endScroll) {
              stickyElement.style.top = `${endScroll}px`;
            }
          }
        } else {
          stickyElement.style.top = `${topGap}px`;
        }
        currPos = window.scrollY;
      }
  
      
      function updateSticky() {
        screenHeight = window.innerHeight;
        stickyElementHeight = stickyElement.offsetHeight;
        positionStickySidebar();
      }
      setTimeout(() => {
      window.addEventListener('resize', () => {
          currPos = window.scrollY;
          updateSticky();
        });
  
        document.addEventListener('scroll', updateSticky, {
          capture: true,
          passive: true
        });
      }, 1000);
    }
    window.addEventListener('load', checkScreenWidth);
    window.addEventListener('resize', checkScreenWidth);

    //on window resize, close all details element
  let lw = $(window).width();
  $(window).resize(function(){
      if($(window).width() != lw){
        $('details').removeAttr('open');
      }
      lw = $(window).width();
  });


});